import Home from './views/main/Home.svelte'
import Login from './views/login/Login.svelte'
import ResetPassword from './views/login/newPass.svelte'
import ForgotPassword from './views/login/forgotPass.svelte'

import { get } from 'svelte/store'
import { isLogged } from './store'
import { wrap } from 'svelte-spa-router/wrap'
import CognitoAuth from './cognito'

const hasLogin = async () => {
    if (window.location.origin.includes('optiline') && ! get(isLogged)) {
        const cognito = new CognitoAuth()
        const isValid = await cognito.isAuthenticated()

        if (! isValid) cognito.logout()
        return isValid
    }
    else return true
}

const routes = {
    '/': wrap({ component: Home, conditions: [ hasLogin ] }),
    '/login': Login,
    '/newPassword': ResetPassword,
    '/forgotPassword': ForgotPassword,
}

export default routes
